import ProductGalleryPresenter from "../components/product-gallery/presenter/product-gallery";

const galleryElement = document.querySelector(`.product-gallery`);
const productGalleryComponent = new ProductGalleryPresenter(galleryElement);
productGalleryComponent.init();
